export const autoScrollCalendarStorageKey = 'auto-scroll-calendar';
export const assignmentSortStorageKey = 'assignment-sorting';
export const viewTripDetailsOnHoverStorageKey = 'view-trip-details-on-hover';

// Hover-to-open timing for the trip details popover (dispatch calendar).
export const TRIP_DETAILS_HOVER_OPEN_DELAY_MS = 300;
// Grace period so moving the pointer across the gap between the event tile and
// the popover content (the side offset + arrow) doesn't close it.
export const TRIP_DETAILS_HOVER_CLOSE_DELAY_MS = 250;

export enum AssignmentSorting {
  DRIVER_NAME = 'driver_name',
  END_TIME = 'end_time',
  START_TIME = 'start_time',
  VEHICLE_NAME = 'vehicle_name',
}
